import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {metaTags_data} from './constants/AppConstants'
import MetaTags from './meta/MetaTags'
import '@mdi/font/css/materialdesignicons.min.css'
import {onMessageListener, requestNotificationPermission} from '../firebase'
import {detectIncognito} from 'detectincognitojs'
import './services/globalAxiosInterceptor' // Initialize global axios interceptor


const App = () => {

  useEffect(() => {   
    // Request notification permission and get the FCM token if not in incognito mode
    detectIncognito().then((result: {isPrivate: boolean}) => {
      result.isPrivate ? console.warn('Incognito mode is enabled') : requestNotificationPermission()
    })

    // Listen for messages when the app is open
    onMessageListener().then((payload) => {
      // toast.warn(`${(payload as any).notification.title}: ${(payload as any).notification.body
      // } `)
    })

  }, [])

  return (
    <>
      {/* meta tags for SEO */}
      <MetaTags
        siteName={metaTags_data.siteName}
        description={metaTags_data.description}
        logo={metaTags_data.logo}
        URL={window.location.href}
      />


      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <Outlet />
            <MasterInit />
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </>
  )
}

export {App}
